import Badge from '@shared/components/Badge';
import { ALARM_STATES, alarmStateLabel, fmtDateTime } from '@/lib/alarmLabels';
import type { AlarmState } from '@/services/api';

/**
 * El estado de una alarma. Una silenciada dice hasta cuándo en el `title`.
 */
export default function AlarmStateBadge({
  state,
  silencedUntil,
}: {
  state: AlarmState | string | null | undefined;
  silencedUntil?: string | null;
}) {
  if (!state) return null;
  const meta = (ALARM_STATES as Readonly<Record<string, (typeof ALARM_STATES)[AlarmState]>>)[state];
  const label = alarmStateLabel(state);
  const title = state === 'silenced' && silencedUntil ? `${label} hasta ${fmtDateTime(silencedUntil)}` : label;
  return (
    <Badge tone={meta?.tone ?? 'neutral'} icon={meta?.icon} title={title}>
      {label}
    </Badge>
  );
}
